import { NOTIFICATION_TYPE } from '../notifications';

export function inviteInboxItemId(workspaceId, inviteId) {
  return `invite:${workspaceId}:${inviteId}`;
}

export function inviteSeenStorageKey(userEmail) {
  const user = String(userEmail || 'anon').toLowerCase();
  return `fokus:inbox-invites-seen:${user}`;
}

function canUseStorage() {
  return typeof localStorage !== 'undefined';
}

export function loadSeenInviteIds(userEmail) {
  if (!canUseStorage()) return new Set();
  try {
    const raw = localStorage.getItem(inviteSeenStorageKey(userEmail));
    const parsed = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function saveSeenInviteIds(userEmail, ids) {
  if (!canUseStorage()) return;
  try {
    localStorage.setItem(inviteSeenStorageKey(userEmail), JSON.stringify([...ids]));
  } catch {
    /* quota / private mode */
  }
}

export function markInviteSeen(userEmail, itemId) {
  const next = loadSeenInviteIds(userEmail);
  next.add(itemId);
  saveSeenInviteIds(userEmail, next);
  return next;
}

export function markInvitesSeen(userEmail, itemIds = []) {
  const next = loadSeenInviteIds(userEmail);
  for (const id of itemIds) next.add(id);
  saveSeenInviteIds(userEmail, next);
  return next;
}

export function toInviteInboxItem(invite, seenIds) {
  const id = inviteInboxItemId(invite.workspaceId, invite.id);
  const name = String(invite.workspaceName || '').trim() || 'this brain';
  return {
    id,
    type: NOTIFICATION_TYPE.WORKSPACE_INVITE,
    title: `You were invited to ${name}`,
    missionName: name,
    workspaceId: invite.workspaceId,
    inviteId: invite.id,
    createdAt: invite.createdAt || null,
    read: Boolean(seenIds?.has?.(id)),
  };
}
